<!--
 - Author : wanghongling.
 - Date   : 2020/4/3.
 - File   : peopleList.通用更多人员列表
 -->

<template>
  <popup class="people" :title="peopleObj.title" width="710px" @closeEvent="peopleObj.isMore = false">
    <div class="people-list">
      <div class="people-list-item" v-for="(item, index) in peopleObj.list" :key="index">
        <div class="people-list-item-left">
          <el-image
              style="width: 80px; height: 80px;border-radius: 50%"
              :src="item.fileId?(imgUrl+item.fileId):avatar"
              fit="cover"></el-image>
        </div>
        <div class="people-list-item-right">
          <p class="dept-name">{{item.departmentName}}</p>
          <p class="name">{{item.userName}}</p>
          <p class="temper" v-if="item.temp">38.3℃</p>
          <p class="timer" v-if="item.card">08:49:22 打卡</p>
          <p class="timer" v-if="item.endDate">{{item.endDate}} 到期</p>
        </div>
      </div>
    </div>
    <div class="no-the-data h350" v-if="peopleObj.list && peopleObj.list.length===0">
      <div>
        <i class="iconfont icon-content-likes dzi"></i>
        <p>暂无{{peopleObj.title}}</p>
      </div>
    </div>
  </popup>
</template>

<script>
  export default {
    name: 'peopleList',
    data () {
      return {
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg')
      }
    },
    props: {
      peopleObj: {
        default: {
          title: '',
          isMore: false,
          list: []
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .people{
    &-list{
      display: flex;
      flex-wrap: wrap;
      &-item{
        width: 220px;
        padding: 10px 0;
        display: flex;
        align-items: center;
        &-left{
        }
        &-right{
          text-align: left;
          padding-left: 15px;
          font-size: 14px;
          p{
            padding-bottom: 3px;
          }
          p:last-child{
            padding-bottom: 0;
          }
          .dept-name{
            color: #2c9102;
          }
          .name{
            font-size: 15px;
            color: #57fffd;
          }
          .temper{
            color: #fac500;
          }
          .timer{
            color: #88adbc;
          }
        }
      }
    }
    .popup-wraps-content{
      max-height: 655px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/peopleList.vue